// removed by extract-text-webpack-plugin
module.exports = {"widget":"_24ncIuXi11CCkIiqWihUY4","content":"ZB9K3GFXUJMHe-myhhWJQ","title":"_3kEMEyBkgf1Y3A0oAZnZ2M","countContainers":"_2YUUxuBsjR5bn27nO_f3qV","countContainer":"_1mKDfg-SvV1v_cRh1bfYhN","count":"SioRKFDcVz-QnCfvWf0P0","orders":"_2iPjzrem38yPhmWcqxlFMn","orderContainer":"SmgOF4FLrJkcCNpw_zYu7","order":"_1J3OkdCR3foS0AZgxNThJr","invoiceId":"_171XGjFujmAGcNqt1abgZv","boxes":"_36mN_pXmnv4Jad3FphlWD7","box":"_2U1dkmG5eTwHa05nQnpVut"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/ShippedStats/widget.scss
// module id = 1271
// module chunks = 0